import { render, staticRenderFns } from "./Finisheds.vue?vue&type=template&id=2e1b5668&lang=pug&"
import script from "./Finisheds.vue?vue&type=script&lang=js&"
export * from "./Finisheds.vue?vue&type=script&lang=js&"
import style0 from "./Finisheds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports